export const ESTADOS_UBICACION = [
    { valor: 'ok', etiqueta: 'Ubicada', color: '#16a34a' },
    { valor: 'revisar', etiqueta: 'A revisar', color: '#d97706' },
    { valor: 'sin_resultado', etiqueta: 'Sin ubicar', color: '#dc2626' },
    { valor: 'pendiente', etiqueta: 'Pendiente', color: '#607d8b' }
]

export const COLOR_UBICACION_MANUAL = '#2563eb'

export const CENTRO_ARGENTINA = { lat: -38.4, lng: -63.6 }

export const tieneCoordenadas = (iglesia) =>
    iglesia?.latitud !== null && iglesia?.latitud !== undefined &&
    iglesia?.longitud !== null && iglesia?.longitud !== undefined &&
    Number.isFinite(Number(iglesia.latitud)) && Number.isFinite(Number(iglesia.longitud))

export const posicionDeIglesia = (iglesia) => ({ lat: Number(iglesia.latitud), lng: Number(iglesia.longitud) })

export const estadoDeIglesia = (iglesia) => {
    if (['ok', 'revisar'].includes(iglesia.estado) && !tieneCoordenadas(iglesia)) return 'pendiente'
    return ESTADOS_UBICACION.some(item => item.valor === iglesia.estado) ? iglesia.estado : 'pendiente'
}

export const datosDeEstado = (valor) => ESTADOS_UBICACION.find(item => item.valor === valor) || ESTADOS_UBICACION[3]

const esUbicacionManual = (iglesia) => iglesia.origen === 'manual' && estadoDeIglesia(iglesia) === 'ok'

export const colorDePin = (iglesia) => esUbicacionManual(iglesia) ? COLOR_UBICACION_MANUAL : datosDeEstado(estadoDeIglesia(iglesia)).color

export const describirPrecision = (iglesia) => {
    if (esUbicacionManual(iglesia)) return 'Corregida a mano'
    const precision = String(iglesia.precision_google || '')
    if (precision.startsWith('AUTOCOMPLETADO')) {
        const detalle = ['Elegida de las sugerencias de Google']
        if (precision.includes('interseccion')) detalle.push('Esquina de dos calles')
        if (precision.includes('aproximado')) detalle.push('Ubicación aproximada')
        return detalle.join(' · ')
    }
    const partes = []
    if (precision.includes('ROOFTOP')) partes.push('Dirección exacta')
    if (precision.includes('RANGE_INTERPOLATED')) partes.push('Ubicada en la cuadra')
    if (precision.includes('interseccion')) partes.push('Esquina de dos calles')
    else if (precision.includes('GEOMETRIC_CENTER')) partes.push('Centro de la calle o zona')
    if (precision.includes('APPROXIMATE')) partes.push('Solo la localidad o el barrio')
    if (precision.includes('parcial')) partes.push('Coincidencia parcial')
    if (precision.includes('multiple')) partes.push('Varios resultados posibles')
    return partes.join(' · ')
}
